import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PageWrapper = ({ children }) => {
    const location = useLocation();
    const [progress, setProgress] = useState(0);
    const [visible, setVisible] = useState(true);
    const [pageFade, setPageFade] = useState(false);

    useEffect(() => {
        // Reset progress and fade on route change
        setProgress(15);
        setVisible(true);
        setPageFade(false);

        // Animate top loader bar
        const progressTimer = setTimeout(() => {
            setProgress(75);
        }, 100);

        const completeTimer = setTimeout(() => {
            setProgress(100);
        }, 350);

        const fadeOutTimer = setTimeout(() => {
            setVisible(false);
        }, 750);

        // Smooth fade-in of page content
        const contentFadeTimer = setTimeout(() => {
            setPageFade(true);
        }, 50);

        return () => {
            clearTimeout(progressTimer);
            clearTimeout(completeTimer);
            clearTimeout(fadeOutTimer);
            clearTimeout(contentFadeTimer);
        };
    }, [location.pathname]);

    return (
        <div className="relative w-full">
            {/* Top Loading Progress Line with Neon Glow */}
            {visible && (
                <div
                    className="fixed top-0 left-0 h-[3px] bg-gradient-to-r from-cyan-400 to-cyan-500 z-[9999] shadow-[0_0_8px_rgba(34,211,238,0.8),_0_0_2px_rgba(34,211,238,0.5)] transition-all ease-out"
                    style={{ 
                        width: `${progress}%`,
                        opacity: progress === 100 ? 0 : 1,
                        transitionDuration: progress === 100 ? '300ms' : '500ms',
                        transitionTimingFunction: 'cubic-bezier(0.1, 0.8, 0.3, 1)'
                    }}
                ></div>
            )}

            {/* Smooth Page transition container */}
            <div className={`transition-opacity duration-500 ease-out ${pageFade ? 'opacity-100' : 'opacity-0'}`}>
                {children}
            </div>
        </div>
    );
};

export default PageWrapper;
